export const UnAuthorizedResponse = {
    code: 403,
    Message: "Unauthorized due to missing permissions",
};
